export interface CategoryItem {
  id: number;
  title: string;
  imageUrl: string;
  category: string;
  rating: string;
  year: string;
  description: string;
  tags: string[];
}

export const categoryData: Record<string, { name: string; description: string; items: CategoryItem[] }> = {
  dianying: {
    name: '电影',
    description: '海量高清电影资源，涵盖动作、喜剧、科幻、爱情、悬疑等多种类型，每日更新，免费在线观看',
    items: [
      {
        id: 101,
        title: '满江红2',
        imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20epic%20movie%20poster%20with%20grand%20ancient%20palace%20courtyard%20scene%20dramatic%20lighting%20with%20soldiers%20in%20armor%20standing%20in%20formation%20red%20lanterns%20hanging%20warm%20cinematic%20atmosphere%20intense%20dramatic%20mood&width=400&height=600&seq=cat-dy-101&orientation=portrait',
        category: 'dianying',
        rating: '9.1',
        year: '2026',
        description: '继第一部票房神话后，张艺谋导演携原班人马再度打造恢弘历史巨制，讲述南宋末年一段荡气回肠的忠义传奇。',
        tags: ['历史', '悬疑', '剧情'],
      },
      {
        id: 102,
        title: '流浪地球3',
        imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20featuring%20a%20massive%20planet%20with%20glowing%20engines%20in%20deep%20space%20dramatic%20cinematic%20lighting%20with%20warm%20orange%20and%20cool%20teal%20contrast%20futuristic%20spaceships%20flying%20toward%20the%20planet%20against%20starry%20backdrop&width=400&height=600&seq=cat-dy-102&orientation=portrait',
        category: 'dianying',
        rating: '9.2',
        year: '2026',
        description: '人类文明的命运悬于一线，太阳系即将毁灭之际，人类将如何抉择？郭帆导演科幻巨制第三部，视效再升级。',
        tags: ['科幻', '冒险', '灾难'],
      },
      {
        id: 103,
        title: '孤注一掷2',
        imageUrl: 'https://readdy.ai/api/search-image?query=Thriller%20movie%20poster%20with%20intense%20atmosphere%20a%20figure%20looking%20through%20blinds%20in%20dimly%20lit%20room%20suspense%20mood%20with%20cool%20blue%20shadows%20and%20warm%20yellow%20light%20streaks%20noir%20cinematic%20style%20tension%20and%20mystery%20aesthetic&width=400&height=600&seq=cat-dy-103&orientation=portrait',
        category: 'dianying',
        rating: '8.8',
        year: '2026',
        description: '聚焦新型网络诈骗犯罪，真实事件改编，揭露境外诈骗工厂的黑暗内幕，紧张刺激全程无尿点。',
        tags: ['犯罪', '剧情', '惊悚'],
      },
      {
        id: 104,
        title: '封神第二部',
        imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20epic%20movie%20poster%20with%20grand%20scale%20battle%20scene%20ancient%20Chinese%20army%20with%20chariots%20and%20mythical%20beasts%20dramatic%20sky%20with%20lightning%20and%20fire%20epic%20fantasy%20war%20atmosphere%20massive%20scale%20cinematic%20illustration&width=400&height=600&seq=cat-dy-104&orientation=portrait',
        category: 'dianying',
        rating: '8.9',
        year: '2026',
        description: '封神大战全面爆发，姜子牙率众神迎战商朝大军，神话史诗战争场面震撼人心，国产特效巅峰之作。',
        tags: ['奇幻', '战争', '神话'],
      },
      {
        id: 105,
        title: '热辣滚烫2',
        imageUrl: 'https://readdy.ai/api/search-image?query=Heartwarming%20comedy%20movie%20poster%20with%20warm%20tones%20featuring%20a%20sports%20boxing%20gym%20setting%20female%20protagonist%20training%20with%20determination%20sweat%20and%20perseverance%20soft%20golden%20lighting%20inspirational%20mood%20emotional%20journey&width=400&height=600&seq=cat-dy-105&orientation=portrait',
        category: 'dianying',
        rating: '8.5',
        year: '2026',
        description: '贾玲导演续作，延续温暖治愈风格，讲述一个普通人通过拳击找到自我价值的热血故事，笑中带泪。',
        tags: ['喜剧', '运动', '励志'],
      },
      {
        id: 106,
        title: '无名2',
        imageUrl: 'https://readdy.ai/api/search-image?query=Spy%20thriller%20movie%20poster%20set%20in%201940s%20Shanghai%20art%20deco%20style%20with%20figures%20in%20trench%20coats%20and%20fedoras%20standing%20in%20shadowy%20alley%20rain-slicked%20cobblestone%20streets%20moody%20atmospheric%20lighting%20with%20cigarette%20smoke&width=400&height=600&seq=cat-dy-106&orientation=portrait',
        category: 'dianying',
        rating: '8.7',
        year: '2026',
        description: '谍战暗流涌动，无名英雄在敌后展开惊心动魄的情报战。梁朝伟、王一博再度联手，演技炸裂。',
        tags: ['谍战', '剧情', '历史'],
      },
      {
        id: 107,
        title: '飞驰人生3',
        imageUrl: 'https://readdy.ai/api/search-image?query=Racing%20comedy%20movie%20poster%20with%20rally%20cars%20drifting%20on%20mountain%20road%20dust%20flying%20dramatic%20sunset%20lighting%20adrenaline-fueled%20action%20shot%20with%20motion%20blur%20professional%20motorsport%20photography%20style%20exciting%20atmosphere&width=400&height=600&seq=cat-dy-107&orientation=portrait',
        category: 'dianying',
        rating: '8.4',
        year: '2026',
        description: '韩寒执导赛车喜剧系列第三部，沈腾回归饰演过气车手，笑料百出的同时也有热血沸腾的赛车场面。',
        tags: ['喜剧', '运动', '冒险'],
      },
      {
        id: 108,
        title: '毒液3：最后一舞',
        imageUrl: 'https://readdy.ai/api/search-image?query=Superhero%20movie%20poster%20featuring%20a%20dark%20symbiote%20creature%20with%20sharp%20teeth%20and%20white%20eyes%20emerging%20from%20shadows%20glossy%20black%20texture%20against%20neon%20city%20backdrop%20intense%20dynamic%20pose%20cinematic%20comic%20book%20art%20style&width=400&height=600&seq=cat-dy-108&orientation=portrait',
        category: 'dianying',
        rating: '8.2',
        year: '2026',
        description: '汤姆·哈迪回归饰演埃迪·布洛克，毒液与宿主迎来最终篇章，史诗级共生对决，视效炸裂。',
        tags: ['动作', '科幻', '超级英雄'],
      },
    ],
  },
  dianshiju: {
    name: '电视剧',
    description: '热门电视剧全集免费在线观看，涵盖国产剧、古装剧、悬疑剧、都市剧等，同步追剧不等待',
    items: [
      {
        id: 201,
        title: '庆余年 第二季',
        imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20court%20drama%20poster%20with%20misty%20mountain%20landscape%20a%20lone%20figure%20in%20traditional%20flowing%20robes%20standing%20on%20palace%20rooftop%20at%20sunset%20golden%20hour%20lighting%20with%20dramatic%20clouds&width=400&height=600&seq=cat-dsj-201&orientation=portrait',
        category: 'dianshiju',
        rating: '9.5',
        year: '2026',
        description: '范闲回归京都，朝堂风云再起。张若昀、陈道明、吴刚等实力派演员倾情演绎，权谋大戏精彩纷呈。',
        tags: ['古装', '权谋', '剧情'],
      },
      {
        id: 202,
        title: '三体：黑暗森林',
        imageUrl: 'https://readdy.ai/api/search-image?query=Sci-fi%20TV%20series%20poster%20featuring%20mysterious%20cosmic%20scene%20with%20dark%20forest%20metaphor%20three%20suns%20in%20alien%20sky%20silhouettes%20of%20figures%20in%20futuristic%20wasteland%20philosophical%20atmosphere%20stark%20lighting%20contrast&width=400&height=600&seq=cat-dsj-202&orientation=portrait',
        category: 'dianshiju',
        rating: '9.6',
        year: '2026',
        description: '刘慈欣科幻巨著改编，第二部黑暗森林法则震撼登场。面壁计划启动，人类文明面临前所未有的危机。',
        tags: ['科幻', '悬疑', '剧情'],
      },
      {
        id: 203,
        title: '繁花 第二季',
        imageUrl: 'https://readdy.ai/api/search-image?query=Shanghai%20nostalgia%20drama%20poster%20featuring%201990s%20Shanghai%20cityscape%20with%20neon%20lights%20and%20bustling%20streets%20figures%20in%20vintage%20clothing%20walking%20through%20rain-slicked%20streets%20warm%20amber%20glow%20romantic%20retro%20atmosphere&width=400&height=600&seq=cat-dsj-203&orientation=portrait',
        category: 'dianshiju',
        rating: '9.3',
        year: '2026',
        description: '王家卫导演电视剧续作，继续讲述90年代上海滩的商海沉浮与人生百态，胡歌、马伊琍、唐嫣主演。',
        tags: ['都市', '年代', '剧情'],
      },
      {
        id: 204,
        title: '唐朝诡事录之西行',
        imageUrl: 'https://readdy.ai/api/search-image?query=Tang%20dynasty%20mystery%20drama%20poster%20with%20ancient%20Chinese%20supernatural%20detective%20theme%20foggy%20mountain%20path%20with%20traditional%20architecture%20mysterious%20atmosphere%20with%20ethereal%20lighting%20ancient%20folklore%20aesthetic&width=400&height=600&seq=cat-dsj-204&orientation=portrait',
        category: 'dianshiju',
        rating: '9.0',
        year: '2026',
        description: '苏无名与卢凌风踏上西域之路，一路破解离奇案件。古装悬疑探案剧，案情诡异烧脑，演技在线。',
        tags: ['古装', '悬疑', '探案'],
      },
      {
        id: 205,
        title: '大江大河3',
        imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20economic%20reform%20era%20drama%20poster%20featuring%20factory%20industrial%20landscape%20with%20workers%20in%20vintage%20workwear%20standing%20before%20massive%20machinery%20warm%20nostalgic%20tones%20documentary-style%20realism&width=400&height=600&seq=cat-dsj-205&orientation=portrait',
        category: 'dianshiju',
        rating: '9.1',
        year: '2026',
        description: '改革开放浪潮中的奋斗者故事继续。宋运辉、雷东宝、杨巡三人命运交织，见证时代变迁的壮丽史诗。',
        tags: ['年代', '剧情', '励志'],
      },
      {
        id: 206,
        title: '猎罪图鉴2',
        imageUrl: 'https://readdy.ai/api/search-image?query=Crime%20investigation%20drama%20poster%20with%20police%20sketch%20artist%20working%20at%20desk%20under%20dim%20lamp%20light%20forensic%20evidence%20photos%20on%20wall%20moody%20blue%20and%20warm%20tungsten%20lighting%20contrast%20tension%20and%20intellect%20aesthetic&width=400&height=600&seq=cat-dsj-206&orientation=portrait',
        category: 'dianshiju',
        rating: '8.9',
        year: '2026',
        description: '模拟画像师沈翊再出山，凭借超凡的画像能力协助警方破获疑难案件。烧脑推理与人性探讨并存。',
        tags: ['悬疑', '犯罪', '剧情'],
      },
      {
        id: 207,
        title: '与凤行',
        imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%20with%20ethereal%20immortal%20realm%20setting%20floating%20palaces%20among%20clouds%20two%20figures%20in%20flowing%20celestial%20robes%20surrounded%20by%20cherry%20blossom%20petals%20soft%20dreamy%20lighting%20romantic%20fantasy%20atmosphere&width=400&height=600&seq=cat-dsj-207&orientation=portrait',
        category: 'dianshiju',
        rating: '8.6',
        year: '2026',
        description: '赵丽颖、林更新再度合作，仙侠玄幻巨制。魔界女王爷与天界上神的三世情缘，特效精美，画面唯美。',
        tags: ['古装', '仙侠', '爱情'],
      },
      {
        id: 208,
        title: '我的阿勒泰',
        imageUrl: 'https://readdy.ai/api/search-image?query=Pastoral%20life%20drama%20poster%20set%20in%20Xinjiang%20Altay%20region%20with%20vast%20grassland%20and%20snow%20mountains%20nomadic%20herders%20with%20horses%20under%20big%20blue%20sky%20warm%20natural%20lighting%20peaceful%20and%20healing%20atmosphere&width=400&height=600&seq=cat-dsj-208&orientation=portrait',
        category: 'dianshiju',
        rating: '9.2',
        year: '2026',
        description: '改编自李娟同名散文集，讲述新疆阿勒泰地区的温暖故事。辽阔草原，淳朴人情，治愈心灵的佳作。',
        tags: ['文艺', '治愈', '剧情'],
      },
    ],
  },
  zongyi: {
    name: '综艺',
    description: '热门综艺节目高清在线观看，音乐竞演、户外真人秀、脱口秀、美食旅行等精彩内容应有尽有',
    items: [
      {
        id: 301,
        title: '乘风破浪的姐姐 第六季',
        imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20variety%20show%20stage%20with%20colorful%20dynamic%20lighting%20effects%20multiple%20female%20performers%20in%20glamorous%20costumes%20on%20a%20grand%20stage%20with%20LED%20screen%20backdrop%20confetti%20falling%20energetic%20performance%20atmosphere&width=400&height=600&seq=cat-zy-301&orientation=portrait',
        category: 'zongyi',
        rating: '8.9',
        year: '2026',
        description: '姐姐们再度集结！30+女艺人同台竞演，展现成熟女性的魅力与实力。舞台炸裂，情怀满满。',
        tags: ['音乐', '竞演', '女性'],
      },
      {
        id: 302,
        title: '王牌对王牌 第九季',
        imageUrl: 'https://readdy.ai/api/search-image?query=Entertainment%20variety%20show%20stage%20with%20celebrity%20hosts%20and%20guests%20laughing%20together%20on%20colorful%20game%20show%20set%20bright%20studio%20lighting%20fun%20competition%20atmosphere%20confetti%20and%20props%20warm%20inviting%20entertainment%20vibe&width=400&height=600&seq=cat-zy-302&orientation=portrait',
        category: 'zongyi',
        rating: '8.7',
        year: '2026',
        description: '沈腾、贾玲、华晨宇、关晓彤王牌家族回归，经典IP对决欢乐不断，笑料百出，解压神器。',
        tags: ['游戏', '喜剧', '访谈'],
      },
      {
        id: 303,
        title: '奔跑吧 第十二季',
        imageUrl: 'https://readdy.ai/api/search-image?query=Outdoor%20variety%20show%20poster%20with%20celebrity%20cast%20running%20and%20laughing%20on%20a%20sunny%20beach%20setting%20bright%20natural%20lighting%20fun%20energetic%20vibe%20with%20colorful%20sportswear%20blue%20sky%20and%20ocean%20background&width=400&height=600&seq=cat-zy-303&orientation=portrait',
        category: 'zongyi',
        rating: '8.5',
        year: '2026',
        description: '跑男团全新阵容再出发！全国各地极限挑战，爆笑游戏与暖心互动并存，国民综艺持续热播。',
        tags: ['户外', '游戏', '真人秀'],
      },
      {
        id: 304,
        title: '歌手2026',
        imageUrl: 'https://readdy.ai/api/search-image?query=Music%20competition%20show%20stage%20with%20single%20spotlight%20on%20a%20singer%20holding%20microphone%20dramatic%20stage%20lighting%20with%20smoke%20effects%20dark%20audience%20silhouette%20backdrop%20powerful%20emotional%20performance%20moment&width=400&height=600&seq=cat-zy-304&orientation=portrait',
        category: 'zongyi',
        rating: '9.0',
        year: '2026',
        description: '顶级歌手同台竞技，用声音征服舞台。殿堂级音乐盛宴，每一期都是耳朵的极致享受。',
        tags: ['音乐', '竞演', '歌唱'],
      },
      {
        id: 305,
        title: '向往的生活 第八季',
        imageUrl: 'https://readdy.ai/api/search-image?query=Countryside%20slow-life%20variety%20show%20poster%20with%20rustic%20wooden%20house%20surrounded%20by%20green%20rice%20fields%20and%20vegetable%20garden%20warm%20sunset%20lighting%20cooking%20smoke%20from%20chimney%20peaceful%20rural%20Chinese%20village%20atmosphere&width=400&height=600&seq=cat-zy-305&orientation=portrait',
        category: 'zongyi',
        rating: '8.8',
        year: '2026',
        description: '回归田园，享受慢生活。黄磊、何炅带领新老嘉宾体验自给自足的乡村生活，美食与真情并存。',
        tags: ['生活', '美食', '慢综艺'],
      },
      {
        id: 306,
        title: '脱口秀大会 第七季',
        imageUrl: 'https://readdy.ai/api/search-image?query=Stand-up%20comedy%20show%20poster%20with%20single%20comedian%20on%20spotlight%20stage%20holding%20microphone%20confident%20pose%20modern%20comedy%20club%20atmosphere%20with%20brick%20wall%20backdrop%20warm%20stage%20lighting%20laughter%20and%20applause%20energy&width=400&height=600&seq=cat-zy-306&orientation=portrait',
        category: 'zongyi',
        rating: '8.6',
        year: '2026',
        description: '脱口秀新老演员齐聚，用幽默洞察生活。犀利观点、爆笑段子，让你笑到停不下来。',
        tags: ['喜剧', '脱口秀', '语言'],
      },
    ],
  },
  dongman: {
    name: '动漫',
    description: '热门国漫日漫高清在线观看，涵盖热血、奇幻、搞笑、恋爱等多种类型，动漫迷的快乐源泉',
    items: [
      {
        id: 401,
        title: '哪吒之魔童闹海2',
        imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20animated%20film%20poster%20featuring%20a%20rebellious%20young%20deity%20character%20with%20fire%20elements%20swirling%20around%20dramatic%20dynamic%20pose%20traditional%20Chinese%20art%20style%20blended%20with%20modern%20animation%20vibrant%20red%20and%20gold%20color%20scheme&width=400&height=600&seq=cat-dm-401&orientation=portrait',
        category: 'dongman',
        rating: '9.4',
        year: '2026',
        description: '饺子导演现象级国漫续作！哪吒与敖丙的命运再度交织，封神宇宙全新篇章，视效与情感全面升级。',
        tags: ['神话', '动作', '奇幻'],
      },
      {
        id: 402,
        title: '深海 2',
        imageUrl: 'https://readdy.ai/api/search-image?query=Stunning%20Chinese%20animated%20film%20poster%20featuring%20an%20underwater%20fantasy%20world%20with%20bioluminescent%20jellyfish%20and%20coral%20reefs%20a%20young%20character%20floating%20in%20deep%20ocean%20surrounded%20by%20magical%20glowing%20particles%20dreamlike%20atmosphere&width=400&height=600&seq=cat-dm-402&orientation=portrait',
        category: 'dongman',
        rating: '9.3',
        year: '2026',
        description: '田晓鹏导演视觉奇观续作，粒子水墨画风再次突破想象。深海之中的奇幻冒险，治愈又震撼。',
        tags: ['奇幻', '冒险', '治愈'],
      },
      {
        id: 403,
        title: '熊出没·逆转时空',
        imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20with%20two%20cute%20bears%20and%20a%20human%20character%20in%20colorful%20sci-fi%20time%20travel%20setting%20swirling%20clocks%20and%20wormholes%20playful%20adventure%20mood%20bright%20cheerful%20colors%20family-friendly%20animation%20art&width=400&height=600&seq=cat-dm-403&orientation=portrait',
        category: 'dongman',
        rating: '8.5',
        year: '2026',
        description: '熊大熊二光头强开启时空冒险之旅！穿越古今中外，爆笑与感动并存，全家欢动画大片。',
        tags: ['喜剧', '冒险', '亲子'],
      },
      {
        id: 404,
        title: '雾山五行·犀川幻紫林',
        imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20animation%20poster%20with%20martial%20arts%20figure%20wielding%20elemental%20fire%20powers%20in%20misty%20mountain%20bamboo%20forest%20traditional%20Chinese%20painting%20aesthetic%20bold%20brush%20strokes%20dynamic%20action%20frozen%20in%20time&width=400&height=600&seq=cat-dm-404&orientation=portrait',
        category: 'dongman',
        rating: '9.6',
        year: '2026',
        description: '国漫打斗天花板！水墨风格结合顶级作画，五行之力对决妖兽，每一帧都是艺术品。',
        tags: ['动作', '奇幻', '水墨'],
      },
      {
        id: 405,
        title: '时光代理人 第三季',
        imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20urban%20fantasy%20anime%20poster%20with%20two%20young%20men%20standing%20back%20to%20back%20in%20city%20alley%20one%20holding%20camera%20abstract%20clock%20and%20photo%20elements%20floating%20around%20stylish%20character%20design%20moody%20lighting&width=400&height=600&seq=cat-dm-405&orientation=portrait',
        category: 'dongman',
        rating: '9.1',
        year: '2026',
        description: '通过照片穿越时空的二人组再度出击！悬疑烧脑剧情，细腻人物刻画，国产悬疑动漫天花板。',
        tags: ['悬疑', '奇幻', '剧情'],
      },
      {
        id: 406,
        title: '一念永恒 第三季',
        imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20fantasy%20anime%20poster%20with%20young%20cultivator%20in%20white%20robes%20standing%20on%20flying%20sword%20above%20cloud%20sea%20mountain%20peaks%20spiritual%20energy%20glowing%20around%20him%20epic%20immortal%20realm%20aesthetic&width=400&height=600&seq=cat-dm-406&orientation=portrait',
        category: 'dongman',
        rating: '8.8',
        year: '2026',
        description: '白小纯修仙之路继续！搞笑与热血并存，从凡人到仙尊的逆袭之旅，修仙动漫必看之作。',
        tags: ['修仙', '喜剧', '冒险'],
      },
      {
        id: 407,
        title: '镇魂街 第四季',
        imageUrl: 'https://readdy.ai/api/search-image?query=Supernatural%20action%20anime%20poster%20set%20in%20mysterious%20spirit%20street%20realm%20with%20ancient%20Chinese%20guardian%20warrior%20spirits%20standing%20behind%20modern-day%20character%20dramatic%20showdown%20scene%20with%20glowing%20spiritual%20energy%20dark%20and%20intense%20atmosphere&width=400&height=600&seq=cat-dm-407&orientation=portrait',
        category: 'dongman',
        rating: '8.9',
        year: '2026',
        description: '罗刹街的守护者归来！守护灵与寄灵人的羁绊之战，热血沸腾的国漫经典，打斗场面燃爆。',
        tags: ['热血', '战斗', '奇幻'],
      },
      {
        id: 408,
        title: '中国奇谭 第二季',
        imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20folklore%20anthology%20animation%20poster%20featuring%20various%20traditional%20art%20styles%20paper%20cutting%20shadow%20puppet%20ink%20painting%20a%20collection%20of%20mysterious%20Chinese%20monsters%20and%20spirits%20artistic%20and%20cultural%20aesthetic&width=400&height=600&seq=cat-dm-408&orientation=portrait',
        category: 'dongman',
        rating: '9.2',
        year: '2026',
        description: '上美影出品中式奇幻动画短片集，八个独立故事展现中国传统文化之美，想象力与艺术性兼备。',
        tags: ['奇幻', '短片', '国风'],
      },
    ],
  },
};

export const categorySlugs: Record<string, string> = {
  dianying: 'dianying',
  dianshiju: 'dianshiju',
  zongyi: 'zongyi',
  dongman: 'dongman',
};